import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteClosedLeadFollowupAutomation as DeleteClosedLeadFollowupAutomationMutation,
    DeleteClosedLeadFollowupAutomationVariables,
    FollowupLeadAutomationDeleteInput,
} from 'nutshell-graphql-types';

import DELETE_CLOSED_LEAD_FOLLOWUP_AUTOMATION from '../mutations/delete-closed-lead-followup-automation.graphql';

export const useDeleteClosedLeadFollowupAutomation = (): {
    deleteClosedLeadFollowupAutomation: (arg1: FollowupLeadAutomationDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteClosedLeadFollowupAutomation, {loading, error}] = useMutation<
        DeleteClosedLeadFollowupAutomationMutation,
        DeleteClosedLeadFollowupAutomationVariables
    >(DELETE_CLOSED_LEAD_FOLLOWUP_AUTOMATION);

    return {
        deleteClosedLeadFollowupAutomation: (input: FollowupLeadAutomationDeleteInput) =>
            deleteClosedLeadFollowupAutomation({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
